<template>
  <!--begin::Toolbar-->
  <div id="kt_app_toolbar" class="app-toolbar py-6">
    <!--begin::Toolbar container-->
    <div id="kt_app_toolbar_container" class="app-container container-xxl d-flex align-items-start">
      <!--begin::Toolbar container-->
      <div class="d-flex flex-column flex-row-fluid">
        <!--begin::Toolbar wrapper=-->
        <div class="d-flex flex-stack flex-wrap flex-lg-nowrap gap-4 gap-lg-10 pt-6 pb-18 py-lg-13">
          <!--begin::Page title-->
          <div class="page-title d-flex align-items-center me-3">
            <!--begin::Title-->
            <h1 class="page-heading d-flex text-white fw-bolder fs-2 flex-column justify-content-center my-0" v-if="$route.name === 'bookingsadmin'">Bookings</h1>
            <h1 class="page-heading d-flex text-white fw-bolder fs-2 flex-column justify-content-center my-0" v-if="$route.name === 'bookingsdetailadmin'">Booking details</h1>
            <!--end::Title-->
          </div>
          <!--end::Page title-->
          <!--begin::Items-->
          <div class="d-flex gap-4 gap-lg-13" style="display: none; opacity: 0;">
            <!--begin::Item-->
            <div class="d-flex flex-column">
              <!--begin::Number-->
              <span class="text-white fw-bold fs-3 mb-1">€23,467.92</span>
              <!--end::Number-->
              <!--begin::Section-->
              <div class="text-white opacity-50 fw-bold">Avg. Monthly Sales</div>
              <!--end::Section-->
            </div>
            <!--end::Item-->
            <!--begin::Item-->
            <div class="d-flex flex-column">
              <!--begin::Number-->
              <span class="text-white fw-bold fs-3 mb-1">€1,748.03</span>
              <!--end::Number-->
              <!--begin::Section-->
              <div class="text-white opacity-50 fw-bold">Today Spending</div>
              <!--end::Section-->
            </div>
            <!--end::Item-->
            <!--begin::Item-->
            <div class="d-flex flex-column">
              <!--begin::Number-->
              <span class="text-white fw-bold fs-3 mb-1">3.8%</span>
              <!--end::Number-->
              <!--begin::Section-->
              <div class="text-white opacity-50 fw-bold">Overall Share</div>
              <!--end::Section-->
            </div>
            <!--end::Item-->
            <!--begin::Item-->
            <div class="d-flex flex-column">
              <!--begin::Number-->
              <span class="text-white fw-bold fs-3 mb-1">-7.4%</span>
              <!--end::Number-->
              <!--begin::Section-->
              <div class="text-white opacity-50 fw-bold">7 Days</div>
              <!--end::Section-->
            </div>
            <!--end::Item-->
          </div>
          <!--end::Items-->
        </div>
        <!--end::Toolbar wrapper=-->
      </div>
      <!--end::Toolbar container=-->
    </div>
    <!--end::Toolbar container-->
  </div>
  <!--end::Toolbar-->
</template>

<script>
export default {
  name: 'TopbarComponent',
  props: {
    
  },
  mounted() {
    
  }
};
</script>